module.exports = __webpack_public_path__ + "static/media/info_round.39df78c2.svg";